import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ComponentTool } from '../interfaces/componenttool';
import { DefaultValuesService } from './defaultvalues.service';
import { isClusterVisible } from '../config/cluster-visibility.config';


@Injectable()
export class AuthGuardService  {

    constructor(public defaults: DefaultValuesService) {
    }

    async canActivate(route: ActivatedRouteSnapshot) {
        while (!this.defaults.loadInitialData) {
            console.log("Waiting for Initialize UI...")
            await new Promise(r => setTimeout(r, 2000));
        }
        const componentTool = this.defaults.componentTool;
        const isRulebookTool = componentTool === ComponentTool.Rulebook;
        const isMersyTool = componentTool === ComponentTool.Mersy;
        const hasAny = (...flags: boolean[]) => flags.some(Boolean);

        let activate = this.defaults.isadminuser;
        switch (route.data['role']) {
            case 'msuser': activate = (activate || this.defaults.isExternalUser) && isRulebookTool; break;
            case 'countrybackenduser': activate = (activate || this.defaults.isCountryBackendStableUser || this.defaults.isCountryBackendProdUser || this.defaults.isHomeUser) && isRulebookTool; break;
            case 'domainexpertuser': activate = (activate || this.defaults.isDomainExpertUser) && isRulebookTool; break;
            case 'remoteactionuser': activate = (activate || this.defaults.isDomainExpertUser || this.defaults.isTenantRemoteActionAdminUser || this.defaults.isControllerRemoteActionAdminUser) && isRulebookTool; break;
            case 'rulebook_gtl_user': activate = (activate || this.defaults.isMaxRulebookGTL || this.defaults.isDomainExpertUser) && isRulebookTool; break;
            case 'supervisorappuser': activate = (activate || this.defaults.isMaxRulebookSupervisorAppUser) && isRulebookTool; break;
            case 'homeuser': activate = (activate || this.defaults.isHomeUser) && isRulebookTool; break;
            case 'it_domainexpert_user': activate = (activate || this.defaults.isCountryBackendProdUser || this.defaults.isCountryBackendStableUser || this.defaults.isDomainExpertUser || this.defaults.isExternalUser) && isRulebookTool; break;
            case 'umpuser': {
                const isRulebookUmpUser = hasAny(
                    this.defaults.isDevUserManagementPortalUser,
                    this.defaults.isProdUserManagementPortalUser,
                    this.defaults.isEMTManagerUser,
                    this.defaults.isMFGAdminCenterUser,
                    this.defaults.isMFGAdminUser
                ) && isRulebookTool;

                const isMersyUmpUser = hasAny(
                    this.defaults.isMersyAdminUser,
                    this.defaults.isMersyAdminMarketQueryUser,
                    this.defaults.isMersyAdminBranchExcellenceUser,
                    this.defaults.isMersyNiOpsAdminUser,
                    this.defaults.isMersyCDPTaxAdmin,
                    this.defaults.isMersyAdminSafetySystemExcellence,
                    this.defaults.isMersyAdminINCO
                ) && isMersyTool;

                activate = activate || isRulebookUmpUser || isMersyUmpUser;
                break;
            }
            case 'branchexcellence': activate = (activate || isClusterVisible(this.defaults, 'branchexcellence')) && isMersyTool; break;
            case 'globalsystemadmin': activate = (activate || this.defaults.isGlobalSystemAdmin) && isRulebookTool; break;
            case 'usermgmtfldbranchesuser': activate = (activate || this.defaults.isUserMgmtFldBranchesUser) && isRulebookTool; break;
            case 'mfgsettings': activate = (activate || this.defaults.isMFGAdminPDCSUser || this.defaults.isMFGAdminCenterUser) && isRulebookTool; break;
            case 'fieldsettingsuser': activate = (activate || this.defaults.isMFGEquipmentManagerUser || this.defaults.isEMTFactorySupportEngineer || this.defaults.isEMTFieldSupportEngineer) && isRulebookTool; break;
            case 'softwareleaseuser': activate = (activate || this.defaults.isMFGAdminUser || this.defaults.isMFGAdminPDCSUser || this.defaults.isMFGAdminCenterUser || this.defaults.isMFGContractEngineerUser || this.defaults.isMFGEquipmentManagerUser) && isRulebookTool; break;
            case 'mersyuser': activate = (activate || isClusterVisible(this.defaults, 'mersyuser')) && isMersyTool; break;

            case 'marketquery': activate = (activate || isClusterVisible(this.defaults, 'marketquery')) && isMersyTool; break;
            case 'niopsuser': activate = (activate || isClusterVisible(this.defaults, 'niopsuser')) && isMersyTool; break;
            case 'pereportuser': activate = (activate || isClusterVisible(this.defaults, 'tax')) && isMersyTool; break;
            case 'ssxuser': activate = (activate || isClusterVisible(this.defaults, 'safety system excellance tool')) && isMersyTool; break;
            case 'incouser': activate = (activate || isClusterVisible(this.defaults, 'inco')) && isMersyTool; break;
        }
        if (activate === false) {
            window.location.href = "/"; // navigate to home page.
        }
        return true;
    }


}
